<template>
<div>
    <el-dialog :title="title" class="c-dialog-fixed" width="700px" :visible.sync="show" :append-to-body="inDialog" :modal="false" :close-on-click-modal="false" :close-on-press-escape="false" center top="5vh" @open="openDialog" @close="closeDialog">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="mini" status-icon class="c-form-mini">

            <el-row>
                <el-col :span="12">
                    <el-form-item label="选择发件箱:" prop="outbox">
                        <el-select v-model="form.outbox" multiple placeholder="选择发件箱" class="filter-item" style="width: 400px;" filterable allow-create clearable>
                            <el-option v-for="item in outboxlist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="选择邮件模板:" prop="name">
                        <el-select v-model="form.name" placeholder="选择邮件模板名称" class="filter-item" style="width: 400px;" filterable allow-create clearable>
                            <el-option v-for="item in namelist" :key="item.id" :label="item.name" :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="show = false">
                取消
            </el-button>
            <el-button type="primary" @click="title === '发件箱、邮件模板配置' ? sendEmail() : editData()">
                确认
            </el-button>
        </div>
    </el-dialog>

</div>
</template>

<script>
// import waves from '@/directive/waves'
import {
    entity_list_page,
    country_list_all,
    email_outbox_getUsernames,
    template_list_getNames,
    entity_list_all,
    entity_post_email,
    template_list_all,
    entity_list_getReligion,
    entity_list_getLanguage,
    entity_list_getParty,
    entity_list_getRegion,
    entity_list_getType,
    entity_add,
    entity_edit,
    region_list_getRegionByCountry,
    region_list_getRegion2ByRegion
} from '../../api';
import {
    dealResult
} from "../../api/common";

const formInit = {
    country: '', //国家
    region: '', //一级地区
    region2: '', //二级地区
    chinese: '', //中文名称
    english: '', //英文名
    language: '', //语言
    religion: '', //宗教
    party: '', //派别
    type: '', //种类
    relation: '', //从属关系隶属于
    google: '', //谷歌地址链接
    address: '', //地址
    tel: '', //电话
    email: '', //邮箱
    url: '', //网站
    contact: '', //其他联系方式
    businesshours: '', //营业时间

    person: '', //接洽人
    link: '', // 接洽人的联系方式
    count: '', // 联系次数
    remark: '', //备注
}
export default {
    name: 'selectEmail',
    // directives: { waves },
    components: {

    },
    props: {
        module: {
            type: String,
            default: ''
        },
        inDialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: '新增',

            countrylist: [],
            loading: false,
            form: {
                ...formInit
            },
            isPublicOption: [],
            partyOption: [],
            languageOption: [],
            outboxlist: [],
            regionlist: [],
            region2list: [],
            statusOption: [],
            typelist: [],
            namelist: [],
            contypeOption: [{
                    value: '线上',
                    label: '线上'
                },
                {
                    value: '线下',
                    label: '线下'
                }

            ],
            statuslist: [{
                    value: '是',
                    label: '是'
                },
                {
                    value: '否',
                    label: '否'
                }
            ],
            show: false,
            updated: false,
            nowUser: '',

            lander: {},
            file: {},
            query: {},

            rules: {
                outbox: [{
                    required: true,

                    message: '请选择发件箱',
                    trigger: 'change'
                }],
                name: [{
                    required: true,

                    message: '请选择要发送的模板',
                    trigger: 'change'
                }]

            }
        }
    },
    created() {
        this.getItems()
    },
    mounted() {
        this.nowUser = localStorage.getItem('account')
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.getAllTemplate();
        this.getItems();
    },
    methods: {
        openDialog() {
            this.$nextTick(() => {
                if (this.resolve) {
                    this.resolve(this)
                }
            })
        },
        open() {
            this.show = true
            this.getItems()
            return new Promise((resolve, reject) => {
                this.resolve = resolve
            })
        },
        clearValidate() {
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.clearValidate()
            })
        },
        resetFields() {
            this.updated = false
            this.form = {
                ...formInit
            }
            this.clearValidate()
            return this
        },
        closeDialog() {
            const vm = this
            vm.form = {
                ...formInit
            }
            this.resetFields()
        }, // 关闭弹窗操作
        update() {
            this.loading = false
            this.updated = true
            this.show = false
            this.$emit('addRefresh')
            this.resetFields()
        },

        updateForEdit() {
            this.$parent.$emit('addRefresh')
            this.loading = false
            this.updated = true
            this.show = false
            this.resetFields()
        },
        initData(data, title) {

            if (title == 'select') {
                this.title = "发件箱、邮件模板配置"
            } else {
                this.title = "编辑数据"
            }

            this.assign(data)
            this.clearValidate()
        },
        assign(data) {
            this.form = {
                ...this.form,
                ...data
            }

            return this
        },

        sendEmail() {
            this.$refs['form'].validate(() => {
                if (
                    this.form.outbox == null || this.form.outbox == ""
                ) {
                    this.$message({
                        message: '未选中任何邮箱',
                        type: 'warning'
                    })
                    return
                }
                 if (
                    this.form.name == null || this.form.name == ""
                ) {
                    this.$message({
                        message: '未选中任何邮件模板',
                        type: 'warning'
                    })
                    return
                }
                this.form.uid = this.lander.uid;
                this.form.token = this.lander.token;
                this.form.templateName = this.form.name
                entity_post_email(this.form).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success(res.data.msg);
                        this.update()

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })

            })
        },
        editData() {

            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.form.uid = this.lander.uid;
                    this.form.token = this.lander.token;

                    entity_edit(this.form).then((res) => {

                        this.$notify({
                            title: '成功',
                            message: '编辑成功',
                            type: 'success',
                            duration: 2000
                        })
                        this.update()
                    })
                }
            })
        },
        getItems() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            email_outbox_getUsernames(this.query).then((res) => {
                this.outboxlist = res.data.obj
            })

            // template_list_getNames(this.query).then((res) => {
            //     this.namelist = res.data.obj
            // })
        },
        //获取全部不分页数据
        getAllTemplate() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.listLoading = true
            template_list_all(this.query).then((res) => {
                dealResult(res.data);
                console.log(res.data);
                if (res.data.status == 1) {
                    this.namelist = res.data.obj
                    console.log(this.namelist);

                } else {
                    this.$message.error(res.data.msg)
                }
                this.listLoading = false

            })
        },

    }
}
</script>

<style lang="scss" scoped>
</style>
